import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.section`
  height: 300px;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    height: 300px;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    height: 275px;
  }
  position: relative;
  overflow: hidden;
`;

const BlogHeader = () => (
  <Wrapper id='hero' className='hero hero-home bg-gray'>
    <div className='container'>
      <div className='row'>
        <div className='col-xl-8 offset-xl-1 col-lg-12'>
          <a href='{{ site.url }}/blog/'><h1>Stacks on Stacks</h1></a>
          <p>The Serverless Ecosystem Blog by Stackery.</p>
          <div className='row'>
            <div id='search-searchbar' className='input-group mb-3 col-xl-8 col-lg-6 col-md-8 col-sm-9'>
              <input id='search-input' type='text' className='form-control' placeholder='Search' aria-label='Search' aria-describedby='search' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
);

export default BlogHeader;
